"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _lodash = _interopRequireDefault(require("lodash"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _compose = _interopRequireDefault(require("../../hoc/compose"));

var _displayNames = _interopRequireDefault(require("../displayNames"));

var _sideArrowSvg = _interopRequireDefault(require("./sideArrow.svg.js"));

var _textLabel = _interopRequireDefault(require("../textLabel"));

var _infoIcon = _interopRequireDefault(require("../infoIcon"));

var _constants = require("./constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var AccordionSection = /*#__PURE__*/function (_React$Component) {
  _inherits(AccordionSection, _React$Component);

  var _super = _createSuper(AccordionSection);

  function AccordionSection() {
    var _this;

    _classCallCheck(this, AccordionSection);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      isOpen: false
    });

    _defineProperty(_assertThisInitialized(_this), "_toggle", function () {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          isOpen = _this$props.isOpen,
          onToggle = _this$props.onToggle;

      if (disabled) {
        return;
      } // Controlled


      if (typeof isOpen === 'boolean') {
        if (_lodash["default"].isFunction(onToggle)) {
          onToggle(!isOpen);
        } // Uncontrolled

      } else {
        _this.setState({
          isOpen: !_this.state.isOpen
        }, function () {
          if (_lodash["default"].isFunction(onToggle)) {
            onToggle(_this.state.isOpen);
          }
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_isOpen", function () {
      var isOpen = _this.props.isOpen;
      return typeof isOpen === 'boolean' ? isOpen : _this.state.isOpen;
    });

    _defineProperty(_assertThisInitialized(_this), "_getRootClassNames", function () {
      var _this$props2 = _this.props,
          getClassName = _this$props2.getClassName,
          disabled = _this$props2.disabled,
          removePadding = _this$props2.removePadding;
      return getClassName('control-accordion-section') + (disabled ? ' disabled' : '') + (_this._isOpen() ? ' open' : '') + (removePadding ? ' noPadding' : '');
    });

    return _this;
  }

  _createClass(AccordionSection, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          disabled = _this$props3.disabled,
          children = _this$props3.children,
          label = _this$props3.label,
          shouldTranslate = _this$props3.shouldTranslate,
          infoContent = _this$props3.infoContent,
          automationId = _this$props3.automationId,
          dataHook = _this$props3.dataHook;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: this._getRootClassNames(),
        "data-aid": automationId,
        "data-hook": dataHook,
        disabled: disabled
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "accordion-section-header",
        "data-hook": _constants.dataHooks.header,
        onClick: this._toggle,
        "aria-checked": this._isOpen()
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "accordion-section-side-icon"
      }, /*#__PURE__*/_react["default"].createElement(_sideArrowSvg["default"], null)), /*#__PURE__*/_react["default"].createElement("div", {
        className: "accordion-section-label"
      }, /*#__PURE__*/_react["default"].createElement(_textLabel["default"], {
        value: label,
        shouldTranslate: shouldTranslate
      })), !disabled && infoContent && /*#__PURE__*/_react["default"].createElement("div", {
        key: "accordion-section-tooltip",
        className: "accordion-section-tooltip"
      }, /*#__PURE__*/_react["default"].createElement(_infoIcon["default"], {
        dataHook: _constants.dataHooks.tooltip,
        text: infoContent,
        shouldTranslate: shouldTranslate
      }))), this._isOpen() && /*#__PURE__*/_react["default"].createElement("div", {
        key: "accordion-section-container",
        className: "accordion-section-container",
        "data-hook": _constants.dataHooks.children
      }, children));
    }
  }]);

  return AccordionSection;
}(_react["default"].Component);

AccordionSection.displayName = _displayNames["default"].ACCORDION_SECTION;
AccordionSection.propTypes = {
  /** Automation ID - for testing purposes @deprecated */
  automationId: _propTypes["default"].string,

  /** DataHook - for testing purposes */
  dataHook: _propTypes["default"].string,

  /** Textual description for the block */
  label: _propTypes["default"].string,

  /** Add information as a tooltip content */
  infoContent: _propTypes["default"].string,

  /** Disable toggling and click events to happen */
  disabled: _propTypes["default"].bool,

  /** Will be called when the the accordion element is open with (isOpen: boolean) */
  onToggle: _propTypes["default"].func,

  /** Sets the open state of the accordion block and sets the component in a controlled state */
  isOpen: _propTypes["default"].bool,

  /** The content to be rendered when the accordion section is open */
  children: _propTypes["default"].any,

  /** Remove the default side padding from the accordion content, and the bottom padding from the accordion header*/
  removePadding: _propTypes["default"].bool
};
AccordionSection.defaultProps = {
  disabled: false,
  removePadding: false,
  label: ''
};

var _default = (0, _compose["default"])(AccordionSection);

exports["default"] = _default;